import * as React from "react";
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} {...props}>
    <path
      fill="#00c4de"
      d="m16.6 18-6.3-6.3a5.958 5.958 0 0 1-1.725.95A6.1 6.1 0 0 1 6.5 13a6.272 6.272 0 0 1-4.612-1.888A6.279 6.279 0 0 1 0 6.5a6.269 6.269 0 0 1 1.888-4.612A6.276 6.276 0 0 1 6.5 0a6.28 6.28 0 0 1 4.613 1.888A6.26 6.26 0 0 1 13 6.5a6.1 6.1 0 0 1-.35 2.075 5.958 5.958 0 0 1-.95 1.725l6.3 6.3ZM6.5 11a4.342 4.342 0 0 0 3.188-1.312A4.335 4.335 0 0 0 11 6.5a4.342 4.342 0 0 0-1.312-3.187A4.347 4.347 0 0 0 6.5 2a4.323 4.323 0 0 0-3.187 1.313A4.359 4.359 0 0 0 2 6.5a4.331 4.331 0 0 0 1.313 3.188A4.327 4.327 0 0 0 6.5 11Z"
      data-name="Path 1329"
    />
  </svg>
);
export default SvgComponent;
